import { Licenses } from 'types/common';

const defaultRootUrl =
  process.env.NODE_ENV === 'production' ? 'https://www.winamax.fr' : 'https://www.dev.winamax.fr';

const config = window.config || {};

export const RootUrl = config.ROOT_URL || defaultRootUrl;

export const BasePath = config.BASE_PATH || process.env.BASE_PATH || '';

const redirectUrlTo = (category) => `${RootUrl}/signup/redirect.php?category=${category}`;
const bettingRedirectUrlTo = (service) => `${RootUrl}/betting/redirect.php?service=${service}`;
const redirectTo = (service) => `${RootUrl}/redirect/index.php?service=${service}`;

// variable isIOS of lib/useragent is not initialized here
const isIOS = window.navigator.userAgent.indexOf('iPhone') !== -1;
const isPokerEmbedded = config.IS_POKER_EMBEDDED || false;
const isBettingEmbedded = config.IS_BETTING_EMBEDDED || false;
const isEmbedded = isPokerEmbedded || isBettingEmbedded || false;
const isPronos = window.location.pathname === `${BasePath}/pronos`;

export const BettingUrl =
  (isEmbedded && isIOS && 'wam://close') ||
  (isPokerEmbedded && !isBettingEmbedded && !isIOS && 'wam://signin') ||
  redirectUrlTo('playbetting');
export const PokerUrl =
  (isPokerEmbedded && isIOS && 'wam://close') ||
  (isBettingEmbedded && isIOS && 'wam://signin') ||
  (isEmbedded && !isIOS && 'wam://signin') ||
  redirectUrlTo('playpoker');
export const PronosUrl =
  (isEmbedded && isIOS && 'wam://close') || bettingRedirectUrlTo('pronos-join');

export const MyAccountUrl = config.ACCOUNT_URL || redirectUrlTo('account');
export const DepositUrl = redirectUrlTo('deposit');

export const HomeUrl =
  (isPokerEmbedded && !isBettingEmbedded && PokerUrl) ||
  (isBettingEmbedded && BettingUrl) ||
  RootUrl;

export const LoginUrl = (isPronos && PronosUrl) || HomeUrl;

export const ResponsibleGamingUrl = redirectTo('responsible_gaming');

export const getAppleStorePath = (license) => {
  switch (license) {
    case Licenses.FR:
      return 'https://apps.apple.com/fr/app/winamax-paris-sportifs-poker/id385720307';
    case Licenses.ES:
      return 'https://apps.apple.com/es/app/winamax-apuestas-y-p%C3%B3ker/id385720307';
    case Licenses.DE:
      return 'https://apps.apple.com/de/app/winamax-sportwetten/id1575718517';
    default:
      return 'https://apps.apple.com/fr/app/winamax-paris-sportifs-poker/id385720307';
  }
};

export const getGooglePlayPath = () => {
  return 'http://play.google.com/store/apps/details?id=com.winamax.winajs';
};
